module.exports = __webpack_public_path__ + "static/media/sink.d0a0fe48.svg";